import React from 'react';
export function Footer() {
  return <footer className="bg-[#081f17] py-8 px-4 border-t border-brand-mint/5 text-center" data-id="element-85">
      <div className="max-w-4xl mx-auto" data-id="element-86">
        <p className="text-brand-cream/50 text-sm mb-4" data-id="element-87">
          Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <p className="text-brand-cream/40 text-xs" data-id="element-88">
          © {new Date().getFullYear()} Hockey Infantil 360°. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}